import React, { useCallback, useEffect, useRef, useState } from "react";
import { Button, Tabs, Tab } from "react-bootstrap";
import "./App.scss";
import { sample } from "lodash";
import FontFaceObserver from "fontfaceobserver";
import data from "./data/loc-xuan.json";
import images from "./data/image.json";
import ImageSelect from "./components/ImageSelect";
import Viewer from "./components/Viewer";
import { size } from "./components/consts";
import Editor from "./components/Editor";
import CTA from "./components/CTA";
import BrowserAlert from "./components/BrowserAlert";

export default function App() {
  const [image, setImage] = useState(images[0].full);
  const [width, setWidth] = useState(size.width);
  const [height, setHeight] = useState(size.height);
  const [scale, setScale] = useState(1);
  const [textSize, setTextSize] = useState(106);
  const [color, setColor] = useState("#E66465");
  const [text, setText] = useState(
    "Nội dung câu Lời Chúa ở đây. Nội dung câu Lời Chúa ở đây."
  );
  const [book, setBook] = useState("------");
  const [font, setFont] = useState("Oswald");
  const [fontLoaded, setFontLoaded] = useState(false);
  const [toggleEditor, setToggleEditor] = useState(false);
  const [tab, setTab] = useState("image");
  const canvas = useRef();
  const realCanvas = useRef();

  const downloadURI = (uri, name) => {
    var link = document.createElement("a");
    link.download = name;
    link.href = uri;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const fitStageIntoParentContainer = () => {
    var container = document.querySelector("#stage-parent");

    // now we need to fit stage into parent
    var containerWidth = container.offsetWidth;
    var containerHeight = container.offsetHeight;
    // to do this we need to scale the stage
    var hScale = containerWidth / size.width;
    const vScale = containerHeight / size.height;
    const scale = Math.min(hScale, vScale);

    setWidth(size.width * scale);
    setHeight(size.height * scale);
    setScale(scale);
  };

  const exportImage = useCallback(() => {
    if (!realCanvas) return;
    const uri = realCanvas.current.toDataURL();
    downloadURI(uri, "loc-xuan.png");
  }, [realCanvas]);

  const loadFont = useCallback(() => {
    setFontLoaded(false);
    const observer = new FontFaceObserver(font);
    observer
      .load(text)
      .then(() => {
        console.log("Font loaded");
        setFontLoaded(true);
      })
      .catch(() => {
        console.error("Font was failed to load");
        setFontLoaded(true);
      });
  }, [font, text]);

  const randomLocXuan = useCallback(() => {
    const script = sample(data);
    if (!script) {
      // in case cannot get a random script, run this method again
      // randomLocXuan()
    } else {
      setText(script.a);
      setBook(script.b);
    }
  }, []);

  useEffect(() => {
    fitStageIntoParentContainer();
    window.addEventListener("resize", fitStageIntoParentContainer);
    loadFont();
  }, [loadFont]);

  useEffect(() => {
    loadFont();
  }, [text, book, font, loadFont]);

  useEffect(() => {
    setTimeout(() => {
      setToggleEditor(true);
    }, 3000);
  }, []);

  return (
    <div className={`container ${toggleEditor ? "mb-[500px]" : ""} md:mb-10`}>
      <BrowserAlert />
      <div className="md:grid grid-cols-4">
        <div className="col-span-1 bg-slate-700 md:h-screen max-h-screen">
          <div className={`editor ${toggleEditor ? "h-1/2" : ""}`}>
            <div className={`editor-header`}>
              <h5 className={"m-0 text-white font-xl"}>Tùy chỉnh</h5>
              <Button
                variant={"link"}
                onClick={() => setToggleEditor(!toggleEditor)}
                className="animate__animated animate__bounce animate__repeat-3 text-white no-underline"
              >
                {toggleEditor ? "Đóng" : "Mở"}
              </Button>
            </div>
            <div
              className={`editor-inner ${
                toggleEditor ? "" : "hidden md:block"
              }`}
            >
              <Tabs
                defaultActiveKey={"image"}
                activeKey={tab}
                onSelect={(k) => setTab(k)}
                className="editor-tabs"
              >
                <Tab
                  eventKey={"image"}
                  title="Hình nền"
                  className="bg-slate-300 editor-tab"
                >
                  <div className="p-3 h-full max-h-full overflow-auto">
                    <h3>Chọn hình nền</h3>
                    <ImageSelect
                      selectedImage={image}
                      onSelectImage={(img) => {
                        setImage(img);
                      }}
                    />
                  </div>
                </Tab>
                <Tab
                  eventKey={"editor"}
                  title="Font chữ"
                  className="bg-slate-300 editor-tab"
                >
                  <div className="p-3 h-full max-h-full overflow-auto">
                    <h3>Tùy chỉnh font chữ</h3>
                    <Editor
                      font={font}
                      setFont={(font) => setFont(font)}
                      textSize={textSize}
                      setTextSize={(size) => setTextSize(size)}
                      color={color}
                      setColor={(color) => setColor(color)}
                    />
                  </div>
                </Tab>
              </Tabs>
            </div>
          </div>
        </div>
        <div className="col-span-3 bg-gradient-to-br from-slate-50 to-rose-100 md:h-screen md:max-h-screen">
          <Viewer
            canvasRef={canvas}
            canvasRealRef={realCanvas}
            scale={scale}
            image={image}
            text={text}
            book={book}
            fontLoaded={fontLoaded}
            color={color}
            textSize={textSize}
            font={font}
            width={width}
            height={height}
          />
        </div>
        <div className="col-span-4 mt-3 text-right mb-24">
          <CTA randomLocXuan={randomLocXuan} exportImage={exportImage} />
        </div>
      </div>
    </div>
  );
}
